var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.ispreview ? 'preview' : ''},[_c('FormList',{attrs:{"list":_vm.extendField,"data":_vm.formData,"onChange":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }